(function ($) {
    /**
     * Extension saves current active tab and activates it after snippet is applied
     */
    $.nette.ext('bs-tabs', {
        init() {
            let activeTab;

            /**
             * $el HTML element before new snippet applied
             */
            this.ext('snippets', true).before($.proxy(($el) => {
                const $activeTabs = $el.find('ul.ajax-tabs li.active');
                if ($activeTabs.length !== 1) {
                    activeTab = undefined;
                    return;
                }

                activeTab = $activeTabs[0].id !== '' ? $activeTabs[0].id : undefined;
            }, this));

            /**
             * $el HTML element after new snippet applied
             */
            this.ext('snippets', true).after($.proxy(($el) => {
                if (activeTab === undefined) {
                    return;
                }
                $el.find(`#${activeTab} a`).tab('show');
            }, this));
        },
    });
}(jQuery));
